import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

const handle = (err, fallback) => {
    if (err.response?.data) throw err.response.data;
    throw err.message || fallback;
};

// GET the client dropdown list — first row is always a synthetic "Select All" (Clientcode='All')
export const getAllOutstandingClients = async () => {
    try {
        const res = await axios.get(`${base}/Reports/GetAllOutstandingclients`);
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch clients'); }
};

// GET sub-clients for a client — not called when the client is 'All'
export const getSubClientsByClientOSReport = async (clientcode) => {
    try {
        const res = await axios.get(`${base}/Accounts/GetSubClientsbyClientOSReport`, { params: { clientcode } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch sub-clients'); }
};

// GET the outstanding summary grid (aging buckets) for a client/sub-client, CC-scoped server-side by UID/Roleid
export const getClientOutStandingReport = async ({ UID, Roleid, ClientCode, SubClientCode }) => {
    try {
        const res = await axios.get(`${base}/Reports/ClientOutStandingReport`, { params: { UID, Roleid, ClientCode, SubClientCode } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch client outstanding report'); }
};

// GET the per-invoice breakdown behind one summary row
export const getClientOutStandingReportInnerData = async ({ Clientcode, SubClientCode, UID, Roleid }) => {
    try {
        const res = await axios.get(`${base}/Reports/ClientOutStandingReportInnerData`, { params: { Clientcode, SubClientCode, UID, Roleid } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch invoice detail'); }
};
